(() => {
  const LINK_SELECTOR = '.js-cart-upgrade-link';
  let isBusy = false;

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Could not load your basket.');
    }

    return res.json();
  }

  function getLineNumberByKey(cart, lineKey) {
    const items = cart.items || [];
    const index = items.findIndex((item) => item.key === lineKey);
    return index >= 0 ? index + 1 : null;
  }

  async function addVariant(variantId, quantity, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties
      })
    });

    if (!res.ok) {
      throw new Error('Could not upgrade this card.');
    }

    return res.json();
  }

  async function removeLine(lineNumber) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: lineNumber,
        quantity: 0
      })
    });

    if (!res.ok) {
      throw new Error('Could not remove the old card size.');
    }

    return res.json();
  }

  function setBusy(link, busy) {
    if (!link) return;

    if (!link.dataset.originalText) {
      link.dataset.originalText = link.textContent.trim();
    }

    link.setAttribute('aria-disabled', busy ? 'true' : 'false');
    link.style.pointerEvents = busy ? 'none' : '';

    if (busy) {
      link.textContent = 'Updating...';
    } else {
      link.textContent = link.dataset.originalText;
    }
  }

  document.addEventListener('click', async (event) => {
    const link = event.target.closest(LINK_SELECTOR);
    if (!link) return;

    event.preventDefault();

    if (isBusy) return;

    const lineKey = link.dataset.lineKey;
    const upgradeVariantId = parseInt(link.dataset.upgradeVariantId, 10);

    if (!lineKey || !upgradeVariantId) return;

    try {
      isBusy = true;
      setBusy(link, true);

      const cart = await getCart();
      const currentItem = (cart.items || []).find((item) => item.key === lineKey);

      if (!currentItem) {
        throw new Error('That card is no longer in your basket.');
      }

      await addVariant(
        upgradeVariantId,
        currentItem.quantity,
        currentItem.properties || {}
      );

      const refreshedCart = await getCart();
      const oldLineNumber = getLineNumberByKey(refreshedCart, lineKey);

      if (oldLineNumber) {
        await removeLine(oldLineNumber);
      }

      window.location.reload();
    } catch (error) {
      console.error(error);
      alert(error.message || 'Could not upgrade card size. Please try again.');
      setBusy(link, false);
      isBusy = false;
    }
  });
})();